import { motion } from "framer-motion";
import "../styles/websites.css";
import { 
  Store, 
  Building2, 
  Briefcase, 
  ShoppingBag,
  Hotel,
  Utensils,
  HeartPulse,
  GraduationCap
} from "lucide-react";

export default function WebsiteTypesSection() {
  const websiteTypes = [
    { icon: <Store />, title: "Magasins & Boutiques", color: "#3B82F6" },
    { icon: <Building2 />, title: "Entreprises", color: "#10B981" },
    { icon: <Briefcase />, title: "Professionnels", color: "#8B5CF6" },
    { icon: <ShoppingBag />, title: "E-commerce", color: "#F59E0B" },
    { icon: <Hotel />, title: "Hôtels & Restaurants", color: "#EF4444" },
    { icon: <Utensils />, title: "Food & Beverage", color: "#EC4899" },
    { icon: <HeartPulse />, title: "Santé & Bien-être", color: "#06B6D4" },
    { icon: <GraduationCap />, title: "Éducation", color: "#6366F1" },
  ];

  return (
    <section className="websites-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Sites Web pour Tous les Secteurs</h2>
          <p className="section-subtitle">
            Des solutions adaptées à chaque type d'entreprise
          </p>
        </div>
        
        <div className="websites-grid">
          {websiteTypes.map((type, index) => (
            <motion.div 
              key={index}
              className="website-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.05 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, transition: { duration: 0.2 } }}
            >
              <div className="website-icon" style={{ backgroundColor: `${type.color}20`, color: type.color }}>
                {type.icon}
              </div>
              <h3 className="website-title">{type.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}